module.exports = __webpack_public_path__ + "static/media/university-early-access-scheme.bc793c56.jpg";